module.exports = __webpack_public_path__ + "static/media/down_arrow.8f5c2b3b.svg";